import React from 'react';

export default function IconGradientDefs() {
  return (
    <svg className="icon-gradient-defs" style={{ position: 'absolute', width: 0, height: 0 }} aria-hidden>
      <defs>
        <linearGradient id="iconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#00d4ff', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#7b2ff7', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
    </svg>
  );
}
